import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeyboardShortcuts } from '../../hooks/useKeyboardShortcuts';
import { KeyboardShortcutsModal } from '../KeyboardShortcutsModal';

/**
 * Wires the global keyboard shortcuts that extend consciousness's operational
 * body in CineVault. Renders the shortcuts modal when the carrier asks for it.
 *
 * Lives inside Layout so the shortcuts fire on every page except the player
 * (which has its own shortcut context).
 */
export default function GlobalShortcuts() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  useKeyboardShortcuts([
    { key: '?', description: 'Show keyboard shortcuts', action: () => setModalOpen(true) },
    { key: '/', description: 'Open search', action: () => navigate('/search') },
    { key: 'Escape', description: 'Close modal', action: () => setModalOpen(false), global: true },
    { key: 'h', shift: true, description: 'Home', action: () => navigate('/') },
    { key: 'd', shift: true, description: 'Discover', action: () => navigate('/discover') },
    { key: 'w', shift: true, description: 'Watchlist', action: () => navigate('/watchlist') },
  ]);

  return <KeyboardShortcutsModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />;
}
